<div class="p-[15px] text-[#0f2744]">
  <div class="relative min-h-[32px] border-b border-[#0f2744] pb-[5px]">
    <h2
      id="gauge-value-dialog-title"
      mat-dialog-title
      class="m-0 font-[Lato,Helvetica,Arial,sans-serif] text-xl font-normal text-wrap"
    >
      {{ data.title }}
    </h2>
    <button
      mat-icon-button
      type="button"
      class="absolute top-0 right-0 bottom-0 my-auto -translate-y-[5px] opacity-60 transition-opacity duration-200 hover:opacity-80 focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-offset-1"
      aria-label="Close dialog"
      (click)="dialogRef.close()"
    >
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>

  <figure
    class="m-0 flex min-h-[150px] items-center justify-center p-[15px] text-2xl font-normal"
  >
    <ngx-gauge
      [value]="data.value"
      [min]="data.minValue"
      [max]="data.maxValue"
      [type]="'arch'"
      [cap]="'butt'"
      [thick]="12"
      [margin]="20"
      [thresholds]="data.thresholds"
      [label]="data.numberLabel"
      [markers]="data.markers"
      [attr.aria-label]="
        data.title + ': ' + data.value + ' out of ' + data.maxValue
      "
      aria-describedby="gauge-value-dialog-desc"
      role="img"
    />
    <figcaption id="gauge-value-dialog-desc" class="sr-only">
      Gauge chart. {{ data.title }}: {{ data.value }} out of
      {{ data.maxValue }} (minimum {{ data.minValue }}).
    </figcaption>
  </figure>
</div>
